import { QueryClient } from '@tanstack/react-query';

/**
 * 全局唯一的 QueryClient（默认值与原先写在 App.tsx 里的一致）。
 *
 * 抽成独立模块是为了让 authStore 在退出登录时能 clear()：App.tsx 已 import authStore，
 * 反向 import 会成环。管理后台在同一台机器上换管理员登录时，若不清缓存，
 * 新管理员首屏会先渲染上一位管理员拉取过的用户、客户、审核与支付数据。
 */
/**
 * 4xx 是「这个请求本身不对」（无权访问、记录不存在、参数非法），再试一次也不会变对；
 * 且退避空档里 `isLoading` 已翻回 false 而 `error` 仍是 null，
 * 页面 `if (error || !data)` 那一支会先渲染写死的兜底文案，把服务端那句中文盖掉。
 * 5xx 与网络抖动仍按原来的次数重试。
 */
function shouldRetry(failureCount: number, error: unknown): boolean {
  const status = (error as { status?: number })?.status;
  if (typeof status === 'number' && status >= 400 && status < 500) return false;
  return failureCount < 1;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: shouldRetry,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});
